import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneIcon from '@mui/icons-material/Phone';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import LocationOnIcon from "@mui/icons-material/LocationOn";
import {Box, Button, Card, CardContent, Grid, Typography, Stack} from '@mui/material';
import * as React from 'react';
import {useNavigate} from 'react-router-dom';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import {concatStrings, truncateStr} from "../Service";

const InstitutionCard = ({institution}) => {
  const navigate = useNavigate();
  const {mode} = useDarkMode();
  return (
    <Grid item xs={4}>
      <Card
        sx={{border: '2px solid #007FAA', minHeight: 380, width : {xs : '330px', md: '330px' , lg :'377.5px'}}}
        variant="outlined"
        style={{backgroundColor: mode.settings.cardBackgroundColor}}>
        <CardContent>
          <div className={'institution-card-title'}>
            <Typography variant="h3" color="#FFFFFF">
              {/*{truncateStr(institution.name.text, 17)}*/}
              {institution.name.text}

            </Typography>
          </div>
          <Stack
              className={'institution-card-content'}
              style={{backgroundColor: mode.settings.inputBackgroundColor}}
              spacing={0.5}
          >
            <Stack direction={'column'} minHeight={'54px'}>
              <Typography style={{color: mode.settings.textColor2}}>
                Public :
              </Typography>
              <Stack direction="row" sx={{overflowX: 'auto', whiteSpace: 'nowrap'}}>
                {
                    institution.relations && institution.relations.public.length > 0 &&
                    <Typography sx={{fontWeight: 700}} style={{color: mode.settings.textColor3}} variant={'subtitle14'}>
                      {concatStrings(institution.relations.public.map((publicType) => publicType.label.text), 25)}
                    </Typography>

                }
              </Stack>

            </Stack>

            <Stack direction={'column'} minHeight={'54px'}>
              <Typography style={{color: mode.settings.textColor2}}>
                Type d'accompagnements :
              </Typography>
              <Stack direction="row" sx={{overflowX: 'auto', whiteSpace: 'nowrap'}}>
                {
                    institution.relations && institution.relations.specificity.length > 0 &&
                    <Typography sx={{fontWeight: 700}} style={{color: mode.settings.textColor3}} variant={'subtitle14'}>
                      {concatStrings(institution.relations.specificity.map((publicType) => publicType.name.text), 25)}
                    </Typography>
                }
              </Stack>
            </Stack>


          </Stack>

          <div style={{display: 'flex', marginTop: 10}}>
            <LocationOnIcon
                role="img"
                aria-label="Ville de l'établissement"
                sx={{mr: 1}}
                style={{color: mode.settings.textColor4}}
            />
            <Typography
                style={{color: mode.settings.textColor2}}
                component={'div'}
                sx={{mr: 1}}
                variant={'subtitle14'}
            >

            </Typography>
            <Typography
                sx={{fontWeight: 700}}
                style={{color: mode.settings.textColor3}}
                variant={'subtitle14'}
            >
              {truncateStr(institution.city.text, 30)}
            </Typography>
          </div>

          <div style={{display: 'flex', marginTop: 10}}>
            <PhoneIcon
                role="img"
                aria-label="Numéro télépone de l'établissement"
                sx={{mr: 1}}
                style={{color: mode.settings.textColor4}}
            />
            <Typography
                style={{color: mode.settings.textColor2}}
                component={'div'}
                sx={{mr: 1}}
                variant={'subtitle14'}
            >

            </Typography>
            <Typography
                sx={{fontWeight: 700}}
                style={{color: mode.settings.textColor3}}
                variant={'subtitle14'}
            >
              {truncateStr(institution.phone.text, 17)}
            </Typography>
          </div>

          <div style={{display: 'flex', marginTop: 10}}>
            <MailOutlineIcon
                role="img"
                aria-label="Email de l'établissement"
                sx={{mr: 1}}
                style={{color: mode.settings.textColor4}}
            />
            <Typography
                style={{color: mode.settings.textColor2}}
                component={'div'}
                sx={{mr: 1}}
                variant={'subtitle14'}
            >

            </Typography>
            <Typography
                sx={{fontWeight: 700}}
                style={{color: mode.settings.textColor3}}
                variant={'subtitle14'}
            >
              {truncateStr(institution.email.email, 30)}
            </Typography>
          </div>

          <Button
              className="btn-gradient"
              variant="contained"
              size="large"
              startIcon={
                <RemoveRedEyeIcon
                    role={'img'}
                    aria-label="Voir le détail de l'établissement"
                />
              }
              sx={{width: '100%', marginTop: 2}}
              onClick={() => navigate(`/establishment/${institution.id}`)}>
            <Typography variant={'subtitle3'}>Voir la fiche</Typography>
          </Button>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default InstitutionCard;
